export default {

  assets: {
    cast_in: 'Echado en',
    delete_error: 'Se ha producido un error al borrar este asset. Es probable que haya datos vinculados a él. ¿Está seguro de que este tipo de asset no tiene ninguna tarea vinculada a él?',
    delete_text: '¿Está seguro de que desea eliminar {name} de su base de datos?',
    edit_fail: 'La creación o edición falló, se produjo un error.',
    edit_success: 'Asset fijo {name} tratado con éxito.',
    edit_title: 'Editar asset fijo',
    empty_list: 'No hay ningún asset en la producción. ¿Qué tal si creamos algunos?',
    empty_list_client: 'No hay ningún asset en esta producción.',
    new_asset: 'Añadir un asset',
    new_assets: 'Añadir assets',
    new_success: 'Asset fijo {name} creado con éxito.',
    no_cast_in: 'Este asset no es lanzado en ninguna toma.',
    number: 'bienes',
    restore_text: '¿Está seguro de que desea restaurar {name} en su base de datos?',
    restore_error: 'Se ha producido un error al restaurar este asset.',
    tasks: 'Tareas de los assets',
    title: 'Assets',
    fields: {
      description: 'Descripción',
      episode: 'Ep.',
      name: 'Nombre',
      production: 'Prod',
      time_spent: 'Tiempo',
      type: 'Tipo',
      hidden_from_client: 'Mostrado al cliente'
    }
  },

  asset_types: {
    all_asset_types: 'Todos los tipos de assets',
    delete_text: '¿Está seguro de que desea eliminar {name} de su base de datos?',
    delete_error: 'Se ha producido un error al borrar este tipo de asset. Es probable que haya datos vinculados a él. ¿Está seguro de que este tipo de asset no tiene ningún asset vinculado a él?',
    edit_title: 'Editar tipo de asset fijo',
    new_asset_type: 'Añadir un tipo de asset fijo',
    number: 'tipo de assets | tipos de assets',
    title: 'Tipos de assets',
    production_title: 'Estadísticas de tipos de assets',
    fields: {
      name: 'Nombre'
    }
  },

  breakdown: {
    all_assets: 'Todos los assets disponibles',
    edit_label: 'Cambiar la etiqueta de asset',
    empty: 'Fundición en vacío',
    label: 'Etiqueta',
    text_mode: 'Mode de texto',
    title: 'Casting',
    options: {
      fixed: 'fijo',
      animate: 'animado'
    }
  },

  comments: {
    add_attachment: 'Añadir un anexo...',
    add_comment: 'Añadir un comentario...',
    add_checklist: 'Agregar lista de verificación',
    add_preview: 'Adjuntar vista previa',
    change_preview: 'Cambiar la vista previa',
    choose: 'Choose',
    comment_from_client: 'Comentario del cliente',
    empty_text: 'Este comentario está vacío',
    edit_title: 'Editar cómo',
    error: 'Se ha producido un error al publicar un comentario',
    no_file_attached: 'No se adjunta ningún archivo',
    post_status: 'Publicar cómo',
    retake: 'Retomar',
    pin: 'Alfiler',
    pinned: 'inmovilizado',
    revision: 'modificación',
    text: 'Texto',
    unpin: 'Desenganchar',
    validated: 'Validado!',
    validation_required: 'Validación Requerida',
    set_status_to: 'Fijar el status en',
    task_placeholder: 'Nuevo articulo...',
    fields: {
      text: 'texto'
    }
  },

  custom_actions: {
    delete_text: '¿Está seguro de que desea eliminar una acción personalizada {name} de su base de datos?',
    delete_error: 'Se ha producido un error al eliminar esta acción personalizada.',
    edit_title: 'Editar una acción personalizada',
    new_custom_action: 'Añadir una acción personalizada',
    number: 'acción personalizada | acciones personalizadas',
    run_for_selection: 'Ejecute una acción personalizada para las tareas seleccionadas:',
    title: 'Acciones personalizadas',
    fields: {
      name: 'Nombre',
      url: 'URL',
      entity_type: 'Tipo de entidad',
      is_ajax: 'Usar AJAX'
    },
    entity_types: {
      all: 'Todos',
      shot: 'Plan',
      asset: 'Asset'
    }
  },

  entities: {
    build_filter: {
      asset_type: 'Tipo de asset',
      all_types: 'Todo tipos de asset',
      assignation: 'Asignación',
      assignation_exists_for: 'La asignación existe para',
      assigned_to: 'Asignado a',
      descriptor: 'Metadatos',
      equal: 'Igual',
      in: 'En',
      no_assignation_for: 'No existe ninguna asignación para',
      no_filter: 'No hay filtro',
      not_equal: 'No igual',
      not_assigned_to: 'No asignado a',
      status: 'Estado de la tarea',
      thumbnail: 'Presencia de la miniatura',
      title: 'Filtro en...',
      with_thumbnail: 'Con la miniatura',
      without_thumbnail: 'Sin_imagen_pulgada'
    },
    thumbnails: {
      error: 'Un error ocurrió mientras subía las miniaturas',
      explaination: 'Añadir una miniatura requiere establecer una nueva vista previa. Para establecer varias miniaturas al mismo tiempo, debe elegir primero un tipo de tarea que se utilizará para crear las nuevas vistas previas. Las miniaturas se establecerán desde esta nueva vista previa',
      explaination_two: 'Entonces tienes que seleccionar los archivos que quieres subir. Para encontrar las entidades correctas, los nombres de los archivos deben coincidir con el siguiente patrón:',
      shots_pattern: 'NombreDeSecuencia NombreDeDisparo, por ejemplo SQ01_SH01.',
      assets_pattern: 'Nombre de asset del tipo de asset, por ejemplo, Environment_Forest.',
      select_files: 'Seleccion archivos',
      selected_files: 'Archivos seleccionados',
      select_task_type: 'Seleccionar tipo de tarea',
      title: 'Add Thumbnails',
      undefined: 'indefinido',
      undefined_pattern: 'Indefinido',
      upload: 'Agregar miniaturas'
    }
  },

  episodes: {
    all_episodes: 'Todos los episodios',
    delete_error: 'Se ha producido un error al borrar este episodio. Es probable que haya datos vinculados a él. ¿Estás seguro de que este episodio no tiene una secuencia vinculada a él?',
    delete_text: '¿Está seguro de que desea eliminar {name} de su base de datos?',
    edit_title: 'Editar episodio',
    empty_list: 'No hay ningún episodio en la producción. ¿Qué tal si creamos algunos?',
    empty_list_client: 'No hay ningún episodio en esta producción.',
    new_episode: 'Nuevo episodio',
    number: 'episodio | episodios',
    title: 'Estadísticas del episodio',
    fields: {
      name: 'denominar',
      description: 'descripción'
    }
  },

  estimation: {
    title: 'Estimación'
  },

  keyboard: {
    altdown: 'Mueve la selección de una tarea hacia abajo',
    altj: 'Seleccione la vista previa',
    altk: 'Seleccione el siguiente preview',
    altleft: 'Mueve la selección de una tarea a la izquierda',
    altright: 'Mueve la selección de una tarea a la derecha',
    altup: 'Mueve la selección de una tarea hacia arriba',
    annotations: 'Anotaciones',
    draw: 'Activar el modo de dibujo',
    navigation: 'Navegación',
    playlist_navigation: 'Navegación de las Paylists',
    redo: 'Redo',
    remove_annotation: 'Eliminar anotación',
    undo: 'Undo',
    shortcuts: 'Atajos de teclado'
  },

  login: {
    back_to_login: 'Voler al login',
    forgot_password: '¿Olvidó su contraseña?',
    login: 'Iniciar sesión',
    login_failed: 'Error de inicio de sesión, por favor verifique sus credenciales',
    login_page: 'Cancelar',
    redirecting: 'Redirigiendo en {secondsLeft} segundos',
    reset_change_password: 'Cambiar contraseña',
    reset_change_password_form_failed: 'Hay un problema con la contraseña que dio. Por favor, verifique que tenga al menos 7 caracteres y que ambas contraseñas coincidan.',
    reset_change_password_failed: 'Error al cambiar la contraseña. Por favor, reinicie todo el procedimiento de nuevo.',
    reset_change_password_succeed: 'Su contraseña ha sido cambiada con éxito. Por favor, vuelva a la página de inicio de sesión para utilizarlo.',
    reset_change_password_title: 'Introduzca una nueva contraseña',
    reset_password: 'Restablecer contraseña',
    reset_password_failed: 'Error al restablecer la contraseña. Por favor, verifique su correo electrónico.',
    reset_password_succeed: 'Restablecer contraseña correctamente. Por favor, compruebe su bandeja de entrada.',
    reset_password_title: 'Ingrese su correo electrónico para restablecer su contraseña',
    title: 'Iniciar sesión en Kitsu',
    fields: {
      email: 'Correo electrónico',
      password: 'Contraseña',
      password2: 'Contraseña de nuevo'
    }
  },

  main: {
    about: 'Acerca de',
    add: 'añadir',
    all: 'Todos',
    all_assets: 'Todos assets',
    admin: 'Admin',
    cancel: 'Cancelar',
    clear_selection: 'Borrar la selección actual',
    days_estimated: 'día estimado | días estimados',
    documentation: 'Documentación',
    close: 'Cerrar',
    confirmation: 'Confirmar',
    confirmation_and_stay: 'Confirmar y quedarse',
    date: 'Fecha',
    dark_theme: 'Tema oscuro',
    days_spent: 'días pasados | días pasados',
    delete: 'Borrar',
    delete_all: 'Borrar todo',
    delete_text: '¿Está seguro de que desea eliminar {name} de su base de datos?',
    edit: 'Tratar',
    empty_comment: 'Vaciar comentario',
    end_date: 'Fecha de finalización',
    files_selected: 'archivos seleccionados',
    for: 'Para',
    go_productions: 'Ir a producciones',
    history: 'trayectoria',
    info: 'Información',
    main_pack: 'Main Pack',
    or: 'o',
    no: 'No',
    loading: 'Carga...',
    loading_data: 'Carga de datos',
    loading_error: 'Se ha producido un error al cargar los datos.',
    logout: 'Cierre de sesión',
    modify: 'Modificar',
    minimize: 'Minimizar',
    maximize: 'Maximizar',
    nb_frames: 'marcos | marcos',
    person: 'person',
    profile: 'Perfil',
    production: 'Producción',
    remove: 'Quitar',
    save: 'Guardar',
    sort_by: 'Ordenar por',
    sorted_by: 'Ordenado por',
    start_date: 'Fecha de inicio',
    studio: 'Estudio',
    user: 'Usuario',
    tutorials: 'Tutorials',
    white_theme: 'Tema Blanco',
    yes: 'Sí',
    csv: {
      choose: 'Elige',
      export_file: 'Exportar',
      error_upload: 'Se ha producido un error al cargar el archivo CSV.',
      import_file: 'Importar',
      import_title: 'Importar datos de un archivo CSV',
      legend: 'Leyenda',
      legend_ok: 'Datos reconocidos',
      legend_ignored: 'Datos ignorados',
      legend_missing: 'Datos perdidos',
      legend_disabled: 'Datos que no serán actualizados ni creados',
      legend_overwrite: 'Datos que serán actualizados',
      paste: 'Pegar',
      paste_code: 'Por favor, pegue aquí sus datos CSV:',
      preview: 'See preview',
      preview_episode_name: 'Nombre del episodio',
      preview_title: 'Vista previa de sus datos importados',
      preview_description: 'Sube un archivo .csv para llenar tu pizarra con posts',
      preview_required: 'NB: Los encabezados deben ser incluidos como primera fila.',
      preview_reupload: 'Subir de nuevo el archivo .CSV',
      required_fields: 'Su archivo CSV requiere las siguientes columnas',
      select_file: 'Por favor, seleccione un archivo de una de sus carpetas:',
      tab_select_file: 'Subir un archivo CSV',
      tab_paste_code: 'Pegar un dato CSV',
      upload_file: 'Navegar',
      unknown: 'Columna desconocida',
      options: {
        title: 'Opciones',
        update: 'Actualizar los datos existentes'
      }
    }
  },

  menu: {
    assign_tasks: 'Asignar tareas',
    change_priority: 'Modificar prioridad',
    change_status: 'Status de modificación',
    create_tasks: 'Crear tareas',
    delete_tasks: 'Borrar medidas',
    generate_playlists: 'Generar playlists',
    run_custom_action: 'Ejecutar una acción personalizada',
    set_estimations: 'Fijar estimaciones'
  },

  news: {
    all: 'Todos',
    commented_on: 'comentado',
    infos: 'Información',
    no_news: 'No hay noticias de esta producción ni de este filtro.',
    only_comments: 'Sólo comentarios',
    only_previews: 'Sólo previsualizaciones',
    set_preview_on: 'establecer vista previa en',
    task_status: 'Status de la tarea',
    task_type: 'Tipo de tarea',
    title: 'Últimas noticias'
  },

  not_found: {
    text: 'Había algo mal en el enlace en el que hiciste clic, te animamos a que vuelvas a la página de inicio.',
    title: 'Página no encontrada... ¿buscas algo que has borrado?'
  },

  notifications: {
    and_change_status: 'y ha cambiado el status a',
    assigned_you: 'te asignó a',
    commented_on: 'comentado',
    mention_you_on: 'te mencioné en',
    no_notifications: 'Actualmente no hay ninguna notificación para usted para sus proyectos actuales.',
    title: 'Notificaciones',
    unread_notifications: 'notificación no leída | notificaciones no leídas',
    with_preview: 'con una vista previa'
  },

  people: {
    active: 'Activada',
    active_persons: 'Persona activada | Personas activadas',
    add_member_to_team: 'Añada un miembro al equipo:',
    create_invite: 'Crear y enviar invitación',
    delete_error: 'Se ha producido un error al borrar a esta persona. Es probable que haya datos vinculados a él. ¿Está seguro de que esta persona no tiene ninguna cita o escribió ningún comentario?',
    delete_text: '¿Está seguro de que desea eliminar {personName} de su base de datos?',
    edit_title: 'Tratar persona',
    empty_team: 'No hay nadie en el equipo del proyecto.',
    invite: 'Enviar invitación',
    invite_error: 'Se ha producido un error al enviar la invitación',
    invite_success: 'La invitación fue enviada con éxito',
    new_person: 'Añadir un nuevo empleado',
    no_task_assigned: 'No hay tareas de ejecución asignadas a usted',
    persons: 'persona | personas',
    running_tasks: 'Ejecutar tareas',
    select_person: 'Seleccione una persona....',
    team: 'Equipo',
    title: 'Gente',
    unactive: 'Inasset',
    csv: {
      import_file: 'Importar un archivo.csv',
      export_file: 'Descargar como archivo.csv',
      import_title: 'Importar datos de un archivo CSV',
      required_fields: 'Su archivo CSV requiere las siguientes columnas',
      select_file: 'Por favor, seleccione un archivo de una de sus carpetas:',
      error_upload: 'Se ha producido un error al cargar el archivo CSV.'
    },
    fields: {
      first_name: 'Nombre de pila',
      last_name: 'Apellido',
      email: 'Correo electrónico',
      phone: 'llamar',
      role: 'Papel',
      old_password: 'Contraseña actual',
      password: 'Nueva contraseña',
      password_2: 'Nueva contraseña (repetir)',
      active: 'Asset'
    },
    list: {
      name: 'Nombre',
      email: 'Correo electrónico',
      phone: 'llamar',
      role: 'Papel',
      active: 'Asset'
    },
    role: {
      admin: 'Director del estudio',
      client: 'Mandante',
      manager: 'Supervisor',
      user: 'Artista CG',
      undefined: '',
      vendor: 'Proveedor'
    }
  },

  playlists: {
    add_selection: 'Añade la selección',
    add_shots: 'Añadir shots',
    add_assets: 'Añadir assets',
    add_sequence: 'Añadir secuencia completa',
    add_episode: 'Añadir episodio completa',
    add_movie: 'Añadir film completa',
    building: 'Edificio',
    apply_task_type_change: 'Esto posicionará la última revisión para el tipo de tarea dada en todos los shots.',
    available_build: 'Construcciones disponibles',
    build_daily: 'Diario pendiente',
    build_weekly: 'Todos Pendientes',
    build_mp4: 'Construir .mp4',
    client_playlist: 'Playlist clave',
    created_at: 'Creado en:',
    create_title: 'Crear playlist',
    create_for_selection: 'Crear una playlist para la selección',
    delete_text: '¿Está seguro de que desea eliminar {name} de su base de datos?',
    delete_error: 'Se ha producido un error al eliminar esta lista de reproducción.',
    download_zip: 'Descargar.zip',
    edit_title: 'Editar lista de reproducción',
    failed: 'Fallido',
    for_client: 'El cliente',
    for_studio: 'El estudio',
    last_creation: 'Ultimas creaciones',
    last_modification: 'Ultimas modificaciones',
    loading_error: 'Se ha producido un error en el servidor. Las listas de reproducción no se pueden cargar.',
    new_playlist: 'Añadir una lista de reproducción',
    no_build: 'Sin construcción',
    no_playlist: 'Actualmente no hay ninguna lista de reproducción para este proyecto.',
    no_preview: 'No hay vista previa de esta toma',
    no_selection: 'Por favor, seleccione una lista de reproducción a la izquierda.',
    no_sequence_for_episode: 'No hay secuencia para este episodio',
    no_shot_for_production: 'No hay ninguna toma para esta producción.',
    no_shot_for_sequence: 'No hay ninguna toma para esta secuencia',
    select_shot: 'Por favor, seleccione una toma en la columna de la derecha',
    select_playlist: 'Por favor, seleccione una lista de reproducción en la columna de la izquierda',
    select_task_type: 'Cambiar el tipo de tarea para todos los planes',
    title: 'Listas de reproducción',
    updated_at: 'Actualizado en:',
    remove: 'quitar',
    fields: {
      created_at: 'Creado en',
      for_client: 'Par compartir con',
      for_entity: 'Para la entidad',
      name: 'Nombre',
      updated_at: 'Actualizado en'
    },
    actions: {
      annotation: 'Anotación',
      annotation_text: 'Doble clic en la vista previa para añadir algo de texto',
      annotation_delete: 'Borrar anotación',
      annotation_redo: 'Redo anotación',
      annotation_undo: 'Deshacer anotación',
      annotation_big: 'Grande',
      annotation_medium: 'Medium',
      annotation_small: 'Pequeña',
      change_task_type: 'Cambiar el tipo de tarea',
      comments: 'Mostrar/ocultar comentarios',
      delete: 'Borrar playlist',
      download: 'Descargar…',
      edit: 'Editar playlist',
      entity_list: 'Mostrar/ocultar lista de entidades',
      fullscreen: 'Fullscreen',
      next_frame: 'Próxima frame',
      next_shot: 'Próxima shot',
      pause: 'Pausa',
      play: 'Jugar',
      previous_frame: 'Anterior frame',
      previous_shot: 'Anterior shot',
      split_screen: 'Split screen',
      speed: 'Cambiar velocidad'
    }
  },

  productions: {
    current: 'Producción seleccionada',
    delete_text: '¿Está seguro de que desea eliminar {name} de su base de datos?',
    delete_error: 'Se ha producido un error al eliminar esta producción. Es probable que haya datos vinculados a él. ¿Estás seguro de que esta producción no tiene ninguna tarea, toma o asset relacionado con ella? Kitsu no permite la eliminación de la producción. Si no quieres ver más la producción, puedes cerrarla.',
    edit_title: 'Editar producción',
    new_production: 'Añadir una producción',
    number: 'producción | producciones',
    open_productions: 'Mis producciones',
    picture: 'Cambiar imagen',
    title: 'Producciones',
    home: {
      create_new: 'Crear una nueva producción',
      empty: 'No tienes ninguna producción abierta. ¿Qué tal si creamos uno nuevo?',
      no_task: 'No tiene ninguna tarea asignada. Consulte a su supervisor para ver qué puede hacer!',
      no_prod_for_client: 'No tienes acceso a ninguna producción. Póngase en contacto con su contratista para obtener un acceso.',
      title: 'Producciones en marcha',
      welcome: 'Bienvenido a Kitsu'
    },
    fields: {
      fps: 'SPD',
      name: 'Nombre',
      ratio: 'razonar',
      resolution: 'Resolución',
      status: 'Estado',
      type: 'Tipo'
    },
    metadata: {
      add_explaination: 'Añada los datos específicos requeridos por este proyecto.',
      add_failed: 'Se ha producido un error al añadir metadatos al proyecto.',
      add_new_values: 'Actualmente no hay valores disponibles.',
      available_values: 'Valores disponibles',
      choices: 'Lista de valores',
      delete_text: '¿Está seguro de que desea borrar esta columna y los datos relacionados para todos los assets de esta producción?',
      delete_error: 'Se ha producido un error al eliminar esta columna de metadatos.',
      error: 'Se ha producido un error al añadir la columna de metadatos. Asegúrese de que no hay ninguna columna con un nombre similar y que todos los campos están completos. Si el problema persiste, póngase en contacto con el equipo de soporte.',
      free: 'Valor libre',
      title: 'Add metadata column'
    },

    status: {
      closed: 'Cerrado',
      open: 'Abrir',
      active: 'Abrir',
      archived: 'Cerrado'
    },

    type: {
      short: 'Corto',
      featurefilm: 'Largometraje',
      tvshow: 'programa de televisión'
    }
  },

  profile: {
    change_avatar: 'Cambiar avatar',
    info_title: 'Información',
    language: 'Idioma',
    notifications_enabled: 'Notificaciones de correo electrónico habilitadas',
    notifications_slack_enabled: 'Notificaciones de Slack activadas',
    notifications_slack_user: 'Slack ID',
    password_title: 'Cambiar contraseña',
    timezone: 'Zona horaria',
    title: 'Su perfil',
    avatar: {
      title: 'Cambiar avatar',
      error_upload: 'Se ha producido un error al subir la imagen.'
    },
    change_password: {
      button: 'Cambiar contraseña',
      error: 'Se ha producido un error al cambiar la contraseña. Por favor, verifique su contraseña actual.',
      success: 'Su contraseña ha sido cambiada con éxito!',
      unvalid: 'La confirmación de su nueva contraseña no coincide o es demasiado corta (se esperan al menos 7 caracteres).'
    },
    save: {
      button: 'Guardar cambios',
      error: 'Se ha producido un error al guardar los cambios'
    }
  },

  quota: {
    average: 'Promedio',
    count_label: 'Modo de conteo',
    detail_label: 'Nivel de detalle',
    details_name: 'Nombre',
    details_seconds: 'Segundos',
    details_frames: 'Frames',
    month_label: 'Mes',
    no_quota: 'No hay cuota para este tipo de tarea',
    name: 'Nombre',
    quota_day: 'Cuota por día',
    quota_week: 'Cuota por semana',
    quota_month: 'Cuota por mes',
    year_label: 'Año',
    title: 'Cupos',
    type_label: 'Tipo'
  },

  settings: {
    change_logo: 'Cambiar logotipo',
    integrations: 'Integraciones',
    logo: 'Estudio de logotipos',
    no_logo: 'No hay conjunto de logotipos.',
    set_logo: 'Logotipo de estudio',
    title: 'Ajustes',
    fields: {
      name: 'Nombre del estudio',
      hours_by_day: 'Horas por día',
      slack_token: 'Slack token (opcional)',
      use_original_name: 'Usar el nombre del archivo original para las descargas'
    },
    production: {
      empty_list: 'La lista está actualmente vacía. Significa que todos los datos de los ajustes principales están disponibles para los usuarios. Añada algunas entradas para limitar las opciones de esta producción.'
    },
    save: {
      button: 'Grabar parametrizaciones',
      error: 'Se ha producido un error del servidor al guardar la configuración'
    }
  },

  task_status: {
    delete_text: '¿Está seguro de que desea eliminar {name} de su base de datos?',
    delete_error: 'Se ha producido un error al borrar este estado de la tarea. Es probable que haya datos vinculados a él. ¿Está seguro de que este status de tarea no tiene ninguna tarea vinculada a él?',
    edit_title: 'Editar el estado de la tarea',
    number: 'estado de la tarea | estado de la tarea',
    new_task_status: 'Añadir un status de tarea',
    title: 'Estado de la tarea',
    fields: {
      color: 'Color',
      is_artist_allowed: 'Se permite al artista',
      is_client_allowed: 'Se permite al cliente',
      is_done: 'Se hace',
      is_reviewable: 'Es revisable',
      is_retake: 'Tiene valor de retomar',
      name: 'Nombre',
      short_name: 'Denominación breve'
    }
  },

  task_types: {
    delete_text: '¿Está seguro de que desea eliminar {name} de su base de datos?',
    delete_error: 'Se ha producido un error al eliminar este tipo de tarea. Es probable que haya datos vinculados a él. ¿Está seguro de que este tipo de tarea no tiene ninguna tarea vinculada a ella?',
    edit_title: 'Tratar tipo de tarea',
    new_task_type: 'Añadir un tipo de tarea',
    number: 'tipo de tarea | tipos de tarea',
    title: 'Tipos de tareas',
    fields: {
      dedicated_to: 'Para',
      color: 'Color',
      name: 'Nombre',
      allow_timelog: 'Registro de tiempo',
      priority: 'Prioridad'
    }
  },

  sequences: {
    all_sequences: 'Todas las secuencias',
    delete_text: '¿Está seguro de que desea eliminar {name} de su base de datos?',
    delete_error: 'Se ha producido un error al borrar esta secuencia. Es probable que haya datos vinculados a él. ¿Estás seguro de que esta secuencia no tiene ninguna toma vinculada a ella?',
    edit_title: 'Tratar secuencia',
    empty_list: 'No hay ninguna secuencia en la producción. ¿Qué tal si creamos algunos?',
    empty_list_client: 'No hay secuencia en esta producción.',
    new_sequence: 'Nueva secuencia',
    number: 'secuencia | secuencias',
    title: 'Estadísticas de secuencia',
    fields: {
      name: 'denominar',
      description: 'descripción'
    }
  },

  schedule: {
    title: 'Calendario',
    title_main: 'Calendario principal',
    overall_man_days: 'Días-hombre',
    md: 'md',
    zoom_level: 'Nivel de zoom',
    milestone: {
      add_milestone: 'Añadir hito para',
      edit_milestone: 'Tratar hito para',
      name: 'Nombre',
      error: 'Se ha producido un error al añadir o editar el hito. Por favor, inténtalo de nuevo.'
    }
  },

  shots: {
    casting: 'Casting',
    creation_explaination: 'Para añadir tomas, primero tienes que crear un episodio y una secuencia. Escriba el nombre de un episodio en la parte inferior de la columna de la izquierda y luego haga clic en añadir para crear un nuevo episodio. Seleccione este episodio y repita la misma operación para la secuencia. Finalmente seleccione una secuencia y escriba el nombre de una toma en el campo en la parte inferior de la columna derecha. Haga clic en el botón "Agregar" que aparece a continuación. Tu primera toma fue creada. Ahora puede añadir muchos más! Si no es un programa de televisión, tienes que crear directamente una secuencia.',
    delete_text: '¿Está seguro de que desea eliminar {name} de su base de datos?',
    delete_error: 'Se ha producido un error al borrar esta imagen. Es probable que haya datos vinculados a él. ¿Estás seguro de que esta toma no tiene ninguna tarea relacionada con ella?',
    edit_success: 'Plan {name} editado con éxito.',
    edit_fail: 'La creación o edición falló, se produjo un error. Asegúrese de que no está renombrando la toma con un nombre ya listado para una secuencia dada.',
    edit_title: 'Editar foto',
    empty_list: 'No hay ninguna toma en la producción. ¿Qué tal si creamos algunos?',
    empty_list_client: 'No hay ninguna toma en esta producción.',
    episodes: 'Episodios',
    history: 'Historial de valores plan',
    new_shot: 'Agregar una foto',
    new_shots: 'Añadir tomas',
    new_sequences: 'Añadir secuencias',
    new_episodes: 'Añadir episodios',
    no_casting: 'El lanzamiento de granadas está vacío.',
    number: 'Plan | Disparos',
    manage: 'Crear tomas',
    new_success: 'Plan {name} creado con éxito.',
    padding: 'Acolchado de chupitos',
    restore_text: '¿Está seguro de que desea restaurar {name} en su base de datos?',
    restore_error: 'Se ha producido un error al restaurar esta toma.',
    sequences: 'Secuencias',
    tasks: 'Tareas de los chupitos',
    title: 'Plans',
    fields: {
      description: 'Descripción',
      nb_frames: 'Marcos',
      episode: 'Episodio',
      frame_in: 'En',
      frame_out: 'Fuera',
      fps: 'SPD',
      name: 'Nombre',
      production: 'Prod',
      sequence: 'Secuencia',
      time_spent: 'Tiempo'
    }
  },

  server_down: {
    text: 'Póngase en contacto con el servicio de asistencia técnica de su proveedor, su administrador de sistemas o su departamento de TI para comprender qué es lo que está fallando.',
    title: 'Kitsu encontró un error al alcanzar su API de datos.'
  },

  statistics: {
    count: 'Conteos',
    count_mode: 'Modo de recuento',
    display_mode: 'Modo de visualización',
    frames: 'Marcos',
    pie: 'Gráficos circulares',
    shots: 'Plans'

  },

  tasks: {
    add_preview: 'Añadir vista previa',
    add_preview_error: 'Se ha producido un error al añadir la vista previa.',
    assign: 'Asigne una tarea a: | Asignar {nbSelectedTasks} tareas a:',
    back_to_list: 'volver a la lista',
    bigger: 'Ampliar el panel de tareas',
    change_status_to: 'Cambiar el estado de la tarea a:',
    change_preview: 'Cambiar la vista previa',
    change_priority: 'Cambiar la prioridad a:',
    clear_assignations: 'asignaciones claras',
    comment_image: 'Adjunte una imagen a su comentario',
    create_for_selection: 'Crear tarea para cada celda vacía:',
    create_tasks: 'Añadir tareas',
    create_tasks_shot: 'Añadir tareas para las tomas actuales',
    create_tasks_shot_explaination: 'Va a crear una nueva tarea para cada toma de la lista actual para el tipo de tarea dado. ¿Quieres continuar?',
    create_tasks_shot_failed: 'Se ha producido un error en el servidor durante el proceso de creación.',
    create_tasks_asset: 'Añadir tareas para los assets actuales',
    create_tasks_asset_explaination: 'Va a crear una nueva tarea para cada asset fijo de la lista actual para el tipo de tarea en cuestión. ¿Quieres continuar?',
    create_tasks_asset_failed: 'Se ha producido un error en el servidor durante el proceso de creación.',
    current: 'Tarea a realizar',
    current_status: 'Situación actual',
    delete_all_text: '¿Está seguro de que desea eliminar todas las tareas de {name}? Por favor, confirme escribiendo el nombre del tipo de tarea que desea eliminar en el campo de texto.',
    delete_all_error: 'Ha fallado la eliminación de todas las tareas de un determinado tipo de tarea.',
    delete_error: 'Se ha producido un error al eliminar la tarea.',
    delete_comment: '¿Estás seguro de que quieres borrar el último comentario?',
    delete_comment_error: 'Se ha producido un error al eliminar un comentario.',
    delete_for_selection: 'Eliminar tareas seleccionadas:',
    delete_preview: '¿Estás seguro de que quieres borrar esta vista previa?',
    delete_preview_error: 'Se ha producido un error al eliminar la vista previa.',
    edit_comment: 'Editar cómo',
    done: 'Hecho',
    download_pdf_file: 'Descargar archivo.{extension}',
    feedback: 'retroalimentación',
    full_screen: 'Visualización en pantalla completa',
    hide_assignations: 'Suprimir asignaciones',
    hide_infos: 'Ocultar información adicional',
    my_tasks: 'Mis tareas',
    next: 'tarea siguiente',
    no_assignation_right: 'No se le permite gestionar asignaciones',
    no_comment: 'Actualmente no hay ningún comentario para esta tarea.',
    no_preview: 'Actualmente no hay ninguna vista previa para esta tarea.',
    no_task_selected: 'Ninguna tarea seleccionada',
    number: 'tarea | tareas',
    preview: 'Previsualizaciones',
    previous: 'tarea previa',
    unsubscribe_notifications: 'Darse de baja de las notificaciones',
    select_image_file: 'Por favor, selecciona la imagen de tu disco duro que quieres adjuntar a tu comentario:',
    set_estimations: 'Establecer estimaciones para las tareas seleccionadas:',
    set_preview: 'Establecer esta vista previa como miniatura',
    set_preview_error: 'Se ha producido un error al configurar la vista previa como miniatura.',
    set_preview_done: 'Esta vista previa se utiliza como miniatura para la entidad actual.',
    select_preview_file: 'Por favor, seleccione una imagen de su disco duro para utilizarla como vista previa de la tarea actual:',
    show_assignations: 'Mostrar asignaciones',
    show_infos: 'Mostrar información adicional',
    subscribe_notifications: 'Suscribirse a las notificaciones',
    tasks: 'Tareas',
    validation: 'Validación',
    with_comment: 'Con un comentario...',
    fields: {
      asset_type: 'Tipo de asset',
      assignees: 'Asignados',
      count: 'Cuenta',
      end_date: 'Fecha de finalización',
      due_date: 'Dos fechas',
      duration: 'Duración',
      entity: 'Entidad',
      entity_name: 'Nombre',
      estimation: 'Estimación',
      frames: 'Marco.',
      last_comment: 'Último comentario',
      last_comment_date: 'Último comentario',
      priority: 'Prioridad',
      production: 'Prod',
      real_end_date: 'Fecha de validación',
      real_start_date: 'Fecha WIP',
      retake_count: 'Reasignaciones',
      start_date: 'Fecha de inicio',
      sequence: 'Secuencia',
      task_status: 'Estado',
      task_status_short_name: 'Estado',
      task_type: 'Tipo'
    },
    colors: {
      title: 'Colorear',
      neutral: 'Neutral',
      status: 'Color de estado',
      late: 'Tarde en rojo'
    },
    priority: {
      emergency: 'Emergencia',
      normal: 'Normal',
      high: 'Alto',
      very_high: 'Muy Alto'
    }
  },

  timesheets: {
    detail_level: 'Nivel de detalle',
    done_tasks: 'Tareas realizadas',
    export_timesheet: 'Hoja de horas de exportación',
    hours: 'horario',
    month: 'Mes',
    time_spents: 'Tiempo empleado (horas)',
    title: 'Hojas horarias',
    year: 'Año'
  },

  wrong_browser: {
    title: 'Tu navegador no es compatible con Kitsu',
    text: 'Kitsu sólo puede ser usado con navegadores Firefox y Chrome.'
  }
}
